import React from 'react'
import { IconHistory } from '@tabler/icons-react'

interface EnhancedHistoryButtonProps {
  onClick: () => void
  className?: string
}

const EnhancedHistoryButton: React.FC<EnhancedHistoryButtonProps> = ({ onClick, className }) => {
  return (
    <div
      className={`flex flex-col items-center justify-center cursor-pointer p-3 bg-white border border-gray-200 transition-all duration-300 hover:scale-105 ${className || ''}`}
      onClick={onClick}
    >
      <IconHistory size={28} color="#3A55DD" stroke={1.5} />
      <span className="text-gray-500 text-xs font-medium mt-1">历史报告</span>
    </div>
  )
}

export default EnhancedHistoryButton
